export const MESSAGE_TYPES = {
  GET_APP_CONTEXT: 'GET_APP_CONTEXT',
  OPEN_SIDE_PANEL: 'OPEN_SIDE_PANEL',
  SEND_APP_CONTEXT: 'SEND_APP_CONTEXT',
  SET_APP_HEIGHT: 'SET_APP_HEIGHT',
  SET_CLIPBOARD_TEXT: 'SET_CLIPBOARD_TEXT',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  CONFIRM_NOTIFICATION_CLOSED: 'CONFIRM_NOTIFICATION_CLOSED',
  CONFIRM_NOTIFICATION_CONFIRMED: 'CONFIRM_NOTIFICATION_CONFIRMED',
  GET_APP_STYLES: 'GET_APP_STYLES',
  SEND_APP_STYLES: 'SEND_APP_STYLES',
} as const

export const NOTIFICATION_TYPES = {
  CONFIRM: 'CONFIRM',
  ERROR: 'ERROR',
  MESSAGE: 'MESSAGE',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
} as const

export const PHONE_TYPES = {
  WORK: 'work',
  HOME: 'home',
  OTHER: 'other',
  MOBILE: 'mobile',
  FAX: 'fax',
  PAGER: 'pager',
} as const

export const PROPERTY_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  URL: 'url',
  DATE: 'date',
  DROPDOWN: 'dropdown',
} as const

export const SOCIAL_PROFILE_TYPES = {
  ABOUTME: 'aboutme',
  FACEBOOK: 'facebook',
  FLICKR: 'flickr',
  FORSQUAR: 'forsquare',
  GOOGLE: 'google',
  GOOGLEPLUS: 'googleplus',
  LINKEDIN: 'linkedin',
  QUORA: 'quora',
  TUNGLEME: 'tungleme',
  TWITTER: 'twitter',
  YOUTUBE: 'youtube',
  OTHER: 'other',
} as const

export const STATUSES = {
  ACTIVE: 'active',
  PENDING: 'pending',
  CLOSED: 'closed',
  SPAM: 'spam',
} as const

export const ALLOWED_ORIGINS = [
  'https://secure.helpscout.net',
  'https://hs-app.local.hsenv.io',
]
